import LayoutAppBar from '@/layouts/LayoutAppBar'

import Login from '@/views/single/Login/Login'
import Dashboard from '@/views/single/Dashboard'
import UserRegistration from '@/views/single/UserRegistration'

import StudySolutions from '@/views/study/StudySolutions'

import Practice from '@/views/practice/Practice'
import PracticeDashboard from '@/views/practice/PracticeDashboard'
import PracticeRangeBuilder from '@/views/practice/PracticeRangeBuilder'
import PracticeTrainer from '@/views/practice/PracticeTrainer'
import PracticeStats from '@/views/practice/PracticeStats'
import PracticeSessions from '@/views/practice/PracticeSessions'
import PracticeHands from '@/views/practice/PracticeHands'

import SuspendedUploads from '@/views/analyze/uploads-react/SuspendedUploads.vue'

import Subscription from '@/views/subscription/Subscription'
import SubscriptionOverview from '@/views/subscription/SubscriptionOverview'
import SubscriptionPaymentSelection from '@/views/subscription/SubscriptionPaymentSelection'
import SubscriptionPaymentGate from '@/views/subscription/SubscriptionPaymentGate'
import SubscriptionPaymentConfirmation from '@/views/subscription/SubscriptionPaymentConfirmation'

import UserSettings from '@/views/settings/UserSettings'
import UserAccount from '@/views/settings/UserAccount'
import UserSubscription from '@/views/settings/UserSubscription'
import UserAppearance from '@/views/settings/UserAppearance'
import UserHotkeys from '@/views/settings/UserHotkeys'
import UserGameSettings from '@/views/settings/UserGameSettings'
import UserLanguage from '@/views/settings/UserLanguage'
import UserCredits from '@/views/settings/UserCredits.vue'

import Coaching from '@/views/static/Coaching'
import DetachedTrainerInfo from '@/views/detached/DetachedTrainerInfo'
import DetachedGmfSelector from '@/views/detached/DetachedGmfSelector'
import PracticeDrills from '@/views/practice/PracticeDrills'

import StudyPlansRoot from '@/views/study/plans/StudyPlansRoot'
import StudyPlansDashboard from '@/views/study/plans/StudyPlansDashboard'
import StudyPlanPage from '@/views/study/plans/StudyPlanPage'

import FairPlay from '@/views/fairplay/FairPlay'
import IcmCalculatorView from '@/views/icm/IcmCalculatorView'

import AnalyzeOriginal from '@/views/analyze/original/AnalyzeOriginal'
import SuspendedReports from '@/views/analyze/reports/SuspendedReports'

import WrapUp2023 from '@/views/wrapup/Wrapup2023'
import PokerWizardDashboard from '@/views/pokerWizard/PokerWizardDashboard.vue'
import AnalyzeHandsV3 from '@/views/analyze/AnalyzeHandsV3.vue'
import SuspendedHands from '@/views/analyze/hands/SuspendedHands.vue'
import CryptoGateway from '@/components/Payments/CryptoGateway.vue'

// import SurveyTriton from '@/views/static/surveys/SurveyTriton'
// import SurveyTritonQuestionare from '@/views/static/surveys/SurveyTritonQuestionare'
// import Next from '@/views/next/Next'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login - GTO Wizard',
      routeAlwaysVisible: true,
    },
  },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      title: 'Dashboard - GTO Wizard',
      layout: LayoutAppBar,
    },
  },
  {
    path: '/coaching',
    name: 'Coaching',
    component: Coaching,
    meta: {
      title: 'Coaching - GTO Wizard',
      layout: LayoutAppBar,
    },
  },
  {
    path: '/study-plans',
    name: 'StudyPlansRoot',
    component: StudyPlansRoot,
    redirect: { name: 'StudyPlansDashboard' },
    children: [
      {
        path: 'dashboard',
        name: 'StudyPlansDashboard',
        component: StudyPlansDashboard,
        meta: {
          title: 'Study plans - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
      {
        path: 'plan/:id',
        name: 'StudyPlanPage',
        component: StudyPlanPage,
        meta: {
          title: false, // will be set in component
          layout: LayoutAppBar,
        },
      },
    ],
  },
  {
    path: '/registration',
    name: 'UserRegistration',
    component: UserRegistration,
    meta: {
      title: 'First steps - GTO Wizard',
    },
  },
  {
    path: '/detached-trainer-info',
    name: 'DetachedTrainerInfo',
    component: DetachedTrainerInfo,
    meta: {
      title: 'GTO Wizard',
    },
  },
  {
    path: '/detached-gmf-selector',
    name: 'DetachedGmfSelector',
    component: DetachedGmfSelector,
    meta: {
      title: 'GTO Wizard',
    },
  },

  {
    path: '/study',
    redirect: { name: 'StudySolutions' },
  },
  {
    path: '/study/solutions',
    redirect: { name: 'StudySolutions' },
  },
  {
    path: '/solutions',
    name: 'StudySolutions',
    component: StudySolutions,
    meta: {
      title: 'Solutions - GTO Wizard',
      layout: LayoutAppBar,
    },
  },
  // Currently lives under StudySolutions - Reports tab - plan is to make this a separate page
  // So I'm treating it as one now and am using StudyReports page name in router store
  // {
  //   path: '/reports',
  //   name: 'StudyReports',
  //   component: StudyReports,
  //   meta: {
  //     title: 'Reports - GTO Wizard',
  //     layout: LayoutAppBar,
  //   },
  // },

  {
    path: '/practice',
    name: 'Practice',
    component: Practice,
    redirect: { name: 'PracticePlay' },
    children: [
      {
        path: 'play',
        name: 'PracticePlay',
        component: PracticeDashboard,
        meta: {
          title: 'Practice - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
      {
        path: 'trainer',
        name: 'PracticeTrainer',
        component: PracticeTrainer,
        meta: {
          title: 'Trainer - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
      {
        path: 'range-builder',
        name: 'PracticeRangeBuilder',
        component: PracticeRangeBuilder,
        meta: {
          title: 'Range builder - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
      {
        path: 'stats',
        name: 'PracticeStats',
        component: PracticeStats,
        meta: {
          title: 'Practice stats - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
      {
        path: 'sessions',
        name: 'PracticeSessions',
        component: PracticeSessions,
        meta: {
          title: 'Practice sessions - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
      {
        path: 'hands',
        name: 'PracticeHands',
        component: PracticeHands,
        meta: {
          title: 'Practice hands - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
      {
        path: 'drills',
        name: 'PracticeDrills',
        component: PracticeDrills,
        meta: {
          title: 'Practice drills - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
    ],
  },
  {
    path: '/analyze',
    name: 'AnalyzeOriginal',
    component: AnalyzeOriginal,
    redirect: { name: 'AnalyzeHandsV3' },
    children: [
      {
        path: 'v3/hands',
        name: 'AnalyzeHandsV3',
        component: AnalyzeHandsV3,
        meta: {
          title: 'Hands - GTO Wizard',
          layout: LayoutAppBar,
          pageViewStretched: true,
        },
      },
      {
        path: 'v4/uploads/:uploadsView?',
        name: 'AnalyzeFilesV4',
        component: SuspendedUploads,
        meta: {
          title: 'Uploads - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
      {
        path: 'v4/hands/:unused*',
        name: 'AnalyzeHandsV4',
        component: SuspendedHands,
        meta: {
          title: 'Hands - GTO Wizard',
          layout: LayoutAppBar,
          isShownUnderFlag: 'HANDS_V4',
        },
      },
      {
        path: 'reports/:unused*',
        name: 'GtoReports',
        component: SuspendedReports,
        meta: {
          title: 'Reports - GTO Wizard',
          layout: LayoutAppBar,
          isShownUnderFlag: 'GTO_REP',
        },
      },
    ],
  },

  {
    path: '/user',
    name: 'UserSettings',
    component: UserSettings,
    redirect: { name: 'UserAccount' },
    children: [
      {
        path: 'account',
        name: 'UserAccount',
        component: UserAccount,
        meta: {
          title: 'Account - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
      {
        path: 'subscription',
        name: 'UserSubscription',
        component: UserSubscription,
        meta: {
          title: 'Subscription - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
      {
        path: 'game-settings',
        name: 'UserGameSettings',
        component: UserGameSettings,
        meta: {
          title: 'Game settings - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
      {
        path: 'themes',
        redirect: { name: 'UserAppearance' },
      },
      {
        path: 'appearance',
        name: 'UserAppearance',
        component: UserAppearance,
        meta: {
          title: 'Appearance - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
      {
        path: 'hotkeys',
        name: 'UserHotkeys',
        component: UserHotkeys,
        meta: {
          title: 'Hotkeys - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
      {
        path: 'lang',
        name: 'UserLanguage',
        component: UserLanguage,
        meta: {
          title: 'Language - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
      {
        path: 'credits',
        name: 'UserCredits',
        component: UserCredits,
        meta: {
          title: 'Credits - GTO Wizard',
          layout: LayoutAppBar,
        },
      },
    ],
  },
  {
    path: '/fairplay',
    name: 'FairPlay',
    component: FairPlay,
    meta: {
      title: 'Fair Play - GTO Wizard',
      layout: LayoutAppBar,
    },
  },
  {
    path: '/icm-calculator',
    name: 'IcmCalculatorView',
    component: IcmCalculatorView,
    meta: {
      title: 'ICM calculator - GTO Wizard',
      layout: LayoutAppBar,
    },
  },
  // WrapUp2023
  {
    path: '/wrapup',
    name: 'WrapUp2023',
    component: WrapUp2023,
    meta: {
      title: 'Yearly wrapup - GTO Wizard',
    },
  },
  {
    path: '/subscription',
    name: 'Subscription',
    component: Subscription,
    redirect: { name: 'SubscriptionOverview' },
    children: [
      {
        path: 'tier-overview',
        name: 'SubscriptionOverview',
        component: SubscriptionOverview,
        meta: {
          title: 'Subscription - GTO Wizard',
        },
      },
      {
        path: 'payment-selection',
        name: 'SubscriptionPaymentSelection',
        component: SubscriptionPaymentSelection,
        meta: {
          title: 'Subscription - GTO Wizard',
        },
      },
      {
        path: 'payment-gate',
        name: 'SubscriptionPaymentGate',
        component: SubscriptionPaymentGate,
        meta: {
          title: 'Subscription - GTO Wizard',
        },
      },
      {
        path: 'payment-confirmation',
        name: 'SubscriptionPaymentConfirmation',
        component: SubscriptionPaymentConfirmation,
        meta: {
          title: 'Subscription - GTO Wizard',
        },
      },
      {
        path: 'payment-update',
        name: 'SubscriptionPaymentUpdate',
        component: SubscriptionPaymentConfirmation,
        meta: {
          title: 'Subscription - GTO Wizard',
        },
      },
    ],
  },
  {
    path: '/play',
    name: 'Play',
    component: PokerWizardDashboard,
    meta: {
      layout: LayoutAppBar,
      title: 'Play - GTO Wizard',
      isShownUnderFlag: 'POKERWIZ',
    },
  },

  // {
  //   path: '/survey/triton',
  //   name: 'SurveyTriton',
  //   component: SurveyTriton,
  //   meta: {
  //     title: 'GTO Wizard x Triton giveaway',
  //     // layout: LayoutAppBar,
  //     //
  //   },
  // },
  // {
  //   path: '/survey/triton/questionare',
  //   name: 'SurveyTritonQuestionare',
  //   component: SurveyTritonQuestionare,
  //   meta: {
  //     title: 'GTO Wizard x Triton giveaway',
  //     // layout: LayoutAppBar,
  //     //
  //   },
  // },
  {
    path: '/one-time-crypto-payment/:amount',
    name: 'CryptoGateway',
    component: CryptoGateway,
    props: route => ({
      amount: Number(route.params.amount) || 0,
      isOneTimePayment: true,
    }),
    meta: {
      title: 'Crypto payment - GTO Wizard',
      layout: LayoutAppBar,
    },
  },
  {
    path: '/noexist',
    name: 'NotExistent',
    redirect: { name: 'Dashboard' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: { name: 'Dashboard' },
  },
]

export default routes
